module.exports = __webpack_public_path__ + "img/payment-logos-absa.c0d96664.png";